export interface Country {
    name: string;
    code: string;
    dial_code: string;
    example: string;
}

export const countries: Country[] = [
    { name: 'France', code: 'FR', dial_code: '+33', example: '0619502211' },
    { name: 'United States', code: 'US', dial_code: '+1', example: '2015550123' },
    { name: 'United Kingdom', code: 'GB', dial_code: '+44', example: '7400123456' },
    { name: 'Germany', code: 'DE', dial_code: '+49', example: '15123456789' },
    { name: 'Spain', code: 'ES', dial_code: '+34', example: '612345678' },
    { name: 'Italy', code: 'IT', dial_code: '+39', example: '3123456789' },
    { name: 'Belgium', code: 'BE', dial_code: '+32', example: '470123456' },
    { name: 'Switzerland', code: 'CH', dial_code: '+41', example: '781234567' },
    { name: 'Luxembourg', code: 'LU', dial_code: '+352', example: '621123456' },
];
